import {
    INavigationService
} from "./navigation.service.interface";

import {makeObservable, observable, runInAction} from "mobx";
import {ServiceBase} from "../service-base";
import {IServiceFactory} from "../service-factory.interface";
import {IRouteRender} from "./models/route.interface";
import {ApplicationRoutes} from "./routes/application-routes";

export class NavigationService extends ServiceBase implements INavigationService {
    constructor(services: IServiceFactory) {
        super(services);
        this.applicationRoutes = new ApplicationRoutes(services);
        window.addEventListener('popstate', () => {
            runInAction(() => {
                this.currentRoute = this._matchCurrentRoute();
            })
        });

        this.currentRoute = this._matchCurrentRoute();

        makeObservable(this, {
            currentRoute: observable.ref,
        });
    }

    public readonly applicationRoutes: ApplicationRoutes;

    currentRoute: IRouteRender;

    private _matchCurrentRoute(): IRouteRender {
        for(let route of this.applicationRoutes.routes) {
            if(route.matchLocation(window.location.pathname)) {
                return route;
            }
        }
        return this.applicationRoutes.home;
    }


    push(path: string): void {
        if(this.currentRoute.paths.all(p => p !== path)) {
            window.history.pushState(null, '', path);
        }
    }

    replace(url: string) {
        window.history.replaceState(null, '', url);
    }

    goBack() {
        window.history.back();
    }
}

